import { Editor, Node, Transforms, Range, Path } from 'slate';
import { ReactEditor } from 'slate-react';

import types from '../../elements/types';
import HelptapEditor from '../../helpers';

function canHaveEmptyLineAfter(node) {

  if (node.type === types.HT_STARTUP_EVENT_TEMPLATE) {
    return false;
  } else if (node.type === types.HT_STARTUP_EVENT) {
    return false;
  }

  return true;

}

export default function withCorrectVoidBehavior(editor) {

  const { deleteBackward, insertBreak, normalizeNode } = editor;

  // if current selection is void node, insert a default node below

  function _insertBreak() {

    if (!editor.selection || !Range.isCollapsed(editor.selection)) {
      return insertBreak();
    }

    const selectedNodePath = Path.parent(editor.selection.anchor.path);
    const selectedNode = Node.get(editor, selectedNodePath);
    if (Editor.isVoid(editor, selectedNode)) {
      Editor.insertNode(editor, {
        type: 'paragraph',
        children: [{ text: '' }],
      });
      return;
    }

    insertBreak();

  }

  editor.insertBreak = _insertBreak;

  // if prev node is a void node, remove the current node and select the void node

  function _deleteBackward(unit) {

    if (
      !editor.selection ||
      !Range.isCollapsed(editor.selection) ||
      !Path.equals(editor.selection.anchor.path, [0, 0]) ||
      editor.selection.anchor.offset !== 0
    ) {
      return deleteBackward(unit);
    }

    const parentPath = Path.parent(editor.selection.anchor.path);
    const parentNode = Node.get(editor, parentPath);
    const parentIsEmpty = Node.string(parentNode).length === 0;

    if (parentNode.type === types.TABLE_CELL) {
      HelptapEditor.table.tryDeleteTableCell(editor);
      return;
    }

    const ancestors = Path.ancestors(editor.selection.anchor.path);

    if (Path.equals(ancestors[1], [0]) === true) {
      Transforms.removeNodes(editor);
      ReactEditor.focus(editor);
      return;
    }

    const previousPath = Path.previous(ancestors[1]);
    const previousNode = Node.get(editor, previousPath);

    if (previousNode.type === types.TABLE) {
      HelptapEditor.table.deleteNextNode(editor, previousPath, previousNode, parentPath, parentNode);
      return;
    }

    if (parentIsEmpty) {

      if (Path.hasPrevious(parentPath) === true) {
        const prevNodePath = Path.previous(parentPath);
        const prevNode = Node.get(editor, prevNodePath);
        if (Editor.isVoid(editor, prevNode)) {
          Transforms.removeNodes(editor);
          ReactEditor.focus(editor);
          return;
        }
      } else {
        HelptapEditor.paragraph.toggle(editor);
        return;
      }
    }

    deleteBackward(unit);

  }

  editor.deleteBackward = _deleteBackward;

  function _normalizeNode([node, path]) {

    // If the content is empty, a paragraph is needed to began to write
    if (editor.children.length < 1) {
      HelptapEditor.insertParagraph(editor, {});
      Transforms.select(editor, [0]);
    }

    return normalizeNode([node, path]);

  }

  editor.normalizeNode = _normalizeNode;

  return editor;

};